import $ from 'jquery'

const clsReady = 'is-ready'

function ready()
{
	const $this = $(this)
	const src = $this.data('image') || $this.prop('src')
	const img = new Image()

	img.onload = function()
	{
		$this.addClass(clsReady)
	}

	img.src = src;
}

export default function()
{
	$('img, [data-image]').each(ready)
}



// WEBPACK FOOTER //
// ./public/scripts/src/initializers/image.js